module.exports = __webpack_public_path__ + "media/images/search-black-d84e7f4f867337768770173aef939cee.svg";